import React, { createContext, useCallback, useState } from 'react';

import { StoreConnector } from 'components';

/**
 * @type {React.Context<{
 *  isOpen: boolean,
 *  onOpen: function,
 *  onClose: function
 * }>}
 */
export const StoreConnectContext = createContext();

export function StoreConnectProvider({ children = null }) {
  const [isOpen, setIsOpen] = useState(false);

  const onOpen = useCallback(() => setIsOpen(true), []);
  const onClose = useCallback(() => setIsOpen(false), []);

  return (
    <StoreConnectContext.Provider value={{ isOpen, onOpen, onClose }}>
      {children}
      <StoreConnector.ConnectModal />
    </StoreConnectContext.Provider>
  );
}
